import { isSmartline } from './smartline.js';

// Glazing specification is independent of the door's opening pattern.
// Laminated units list the supplied 33.1 specification without inventing a
// spacer/overall thickness that has not been specified for that construction.
export const leafGlassOptions = [
  { id: 'glass_2k_clear', surcharge: 0, name: '2K 4-16-4 Clear', nameEt: '2K 4-16-4 kirgas klaas', panes: 2, composition: '4-16-4', patterned: false, safety: 'standard' },
  { id: 'glass_2k_patterned', surcharge: 35, name: '2K patterned glass', nameEt: '2K musterklaas', panes: 2, patterned: true, safety: 'standard' },
  { id: 'glass_2k_tempered_clear', surcharge: 45, name: '2K tempered clear glass', nameEt: '2K karastatud kirgas klaas', panes: 2, patterned: false, safety: 'tempered' },
  { id: 'glass_2k_tempered_patterned', surcharge: 80, name: '2K tempered patterned glass', nameEt: '2K karastatud musterklaas', panes: 2, patterned: true, safety: 'tempered' },
  { id: 'glass_2k_laminated_clear', surcharge: 95, name: '2K laminated 33.1 clear glass', nameEt: '2K lamineeritud 33.1 kirgas klaas', panes: 2, patterned: false, safety: 'laminated_33_1' },
  { id: 'glass_3k_clear', surcharge: 45, name: '3K 4-12-4-12-4 Clear', nameEt: '3K 4-12-4-12-4 kirgas klaas', panes: 3, composition: '4-12-4-12-4', patterned: false, safety: 'standard' },
  { id: 'glass_3k_patterned', surcharge: 80, name: '3K patterned glass', nameEt: '3K musterklaas', panes: 3, patterned: true, safety: 'standard' },
  { id: 'glass_3k_tempered_clear', surcharge: 190, name: '3K tempered clear glass', nameEt: '3K karastatud kirgas klaas', panes: 3, patterned: false, safety: 'tempered' },
  { id: 'glass_3k_tempered_patterned', surcharge: 225, name: '3K tempered patterned glass', nameEt: '3K karastatud musterklaas', panes: 3, patterned: true, safety: 'tempered' },
  { id: 'glass_3k_laminated_clear', surcharge: 190, name: '3K laminated 33.1 clear glass', nameEt: '3K lamineeritud 33.1 kirgas klaas', panes: 3, patterned: false, safety: 'laminated_33_1' },
  { id: 'glass_3k_laminated_patterned', surcharge: 225, name: '3K laminated 33.1 patterned glass', nameEt: '3K lamineeritud 33.1 musterklaas', panes: 3, patterned: true, safety: 'laminated_33_1' }
];

export const glassPatterns = [
  { id: 'satin', name: 'Satin' }, { id: 'crepi', name: 'Crepi' },
  { id: 'cotzwold', name: 'Cotzwold' }, { id: 'diamante', name: 'Diamante' },
  { id: 'cathedral', name: 'Cathedral' }
];

export const legacyLeafGlassOptions = [
  { id: 'glass_8mm_clear', name: '8 mm clear glass', nameEt: '8 mm selge klaas', panes: 1, composition: '8', patterned: false, safety: 'standard' },
  { id: 'glass_8mm_frosted', name: '8 mm frosted glass', nameEt: '8 mm matt klaas', panes: 1, composition: '8', patterned: false, safety: 'standard' }
];
export const leafGlassOptionsForFamily = family => isSmartline(family) ? leafGlassOptions : legacyLeafGlassOptions;
export const leafGlassSurcharge = (family, glass) => isSmartline(family)
  ? leafGlassOptions.find(o => o.id === glass)?.surcharge ?? null : null;

export function leafGlassSelection(glass, pattern, family = '60_OUT') {
  if (!isSmartline(family)) return { option: legacyLeafGlassOptions.find(o => o.id === glass) || legacyLeafGlassOptions[0], pattern: null };
  const id = glass === 'glass_8mm_frosted' ? 'glass_2k_patterned'
    : glass === 'glass_8mm_clear' ? 'glass_2k_clear' : glass;
  const option = leafGlassOptions.find(o => o.id === id) || leafGlassOptions[0];
  const selectedPattern = option.patterned ? glassPatterns.find(p => p.id === pattern) || glassPatterns[0] : null;
  return { option, pattern: selectedPattern };
}

export function leafGlassSpecification(glass, pattern) {
  if (glass === 'glass_none') return null;
  const selected = leafGlassSelection(glass, pattern, glass?.startsWith('glass_8mm_') ? 'LEGACY' : '60_OUT');
  return { id: selected.option.id, panes: selected.option.panes, composition: selected.option.composition || null,
    safety: selected.option.safety, pattern: selected.pattern?.id || null };
}

export function leafGlassLabel(glass, pattern, lang = 'en') {
  // Existing cart items retain their original monolithic-glass descriptions.
  if (glass === 'glass_8mm_clear') return lang === 'et' ? '8 mm selge klaas' : '8 mm clear glass';
  if (glass === 'glass_8mm_frosted') return lang === 'et' ? '8 mm matt klaas' : '8 mm frosted glass';
  const option = leafGlassOptions.find(o => o.id === glass);
  if (!option) return null;
  const selected = leafGlassSelection(glass, pattern);
  return `${lang === 'et' ? option.nameEt : option.name}${selected.pattern ? ` · ${selected.pattern.name}` : ''}`;
}

export function isClearLeafGlass(glass) {
  if (['glass_8mm_clear', 'glass_2k_clear', 'glass_4mm_clear'].includes(glass)) return true;
  return leafGlassOptions.some(o => o.id === glass && !o.patterned);
}
